import { DashboardLayout, ChevronDarkRightIcon } from "Components";
import { FC, memo } from "react";
import { Box, Typography } from "@material-ui/core";
import { useLocalization } from "Hooks";
import { fontSizes } from "Theme/Variables";
import { onGetAgreementRequest } from "Stores/Account";
import { useDispatch, useSelector } from "react-redux";
import { agreementsTypes, generateLanguageParam } from "Utils";
import { UserState, userStore } from "Stores/User";

import "./Agreements.scss";

type AgreementsProps = {};

type AgreementstItemType = {
  title: string;
  id: number;
  onClick: () => void;
  itemID: string;
};

const Agreements: FC<AgreementsProps> = memo(() => {
  const dispatch = useDispatch();
  const userData: UserState = useSelector(userStore);
  const isKYCCompleted = userData?.isKYCCompleted;

  const {
    web_title_agreements,
    web_clarification_text,
    web_framework_contract,
    web_ibb_clarification_text,
    web_contracts_acikriza,
    web_istanbulkart_terms_of_use,
    web_contracts_verified_account_header,
    web_contracts_privacy_notice,
    web_contracts_masak_aggrement,
    web_contracts_explicit_consent,
  } = useLocalization();

  const handleAgreementSelect = (AgreementType: number) => {
    dispatch(
      onGetAgreementRequest({
        AgreementType,
        Language: generateLanguageParam(),
      }),
    );
  };

  const agreements: AgreementstItemType[] = [
    {
      title: web_clarification_text,
      onClick: () => handleAgreementSelect(agreementsTypes.AYDINLATMA_METNI),
      id: 7,
      itemID: "seeAydınlatmaMetniBtnTest",
    },
    {
      title: web_framework_contract,
      onClick: () => handleAgreementSelect(agreementsTypes.CERCEVE_SOZLESMESI),
      id: 6,
      itemID: "seeCerceveSozlesmeBtnTest",
    },
    // {
    //   title: web_ibb_clarification_text,
    //   onClick: () => handleAgreementSelect(agreementsTypes.IBB_AYDINLATMA_METNI),
    //   id: 5,
    //   itemID: 'seeIbbAydinlatmaMetniBtnTest',
    // },
    {
      title: web_contracts_acikriza,
      onClick: () => handleAgreementSelect(agreementsTypes.ACIK_RIZA_METNI),
      id: 4,
      itemID: "seeAcikRizaMetniBtnTest",
    },
    {
      title: web_istanbulkart_terms_of_use,
      onClick: () =>
        handleAgreementSelect(agreementsTypes.ISTANBULKART_KULLANIM),
      id: 2,
      itemID: "istanbulKartBtnTest",
    },
  ];

  const kycAgreements: AgreementstItemType[] = [
    {
      title: web_contracts_privacy_notice,
      onClick: () =>
        handleAgreementSelect(agreementsTypes.KYC_AYDINLATMA_METNI),
      id: 12,
      itemID: "kycAydinlatmaMetniBtnTest",
    },
    {
      title: web_contracts_explicit_consent,
      onClick: () => handleAgreementSelect(agreementsTypes.KYC_ACIK_RIZA_METNI),
      id: 13,
      itemID: "kycAcikRizaMetniBtnTest",
    },
    {
      title: web_contracts_masak_aggrement,
      onClick: () => handleAgreementSelect(agreementsTypes.KYC_MASAK_METNI),
      id: 14,
      itemID: "kycMasakMetniBtnTest",
    },
  ];

  return (
    <DashboardLayout backButton>
      <div id="agreements">
        <Typography variant="h3" component="h1" align="center">
          <Box fontWeight={600} className="agreements__title">
            {web_title_agreements}
          </Box>
        </Typography>
        {agreements.map(({ title, onClick, id, itemID }) => (
          <AgreementsItem
            id={id}
            title={title}
            onClick={onClick}
            key={id}
            itemID={itemID}
          />
        ))}

        {isKYCCompleted && (
          <>
            <Typography variant="h3" component="h2" align="center">
              <Box fontWeight={600} className="agreements__kyc-section-title">
                {web_contracts_verified_account_header}
              </Box>
            </Typography>
            {kycAgreements.map(({ title, onClick, id, itemID }) => (
              <AgreementsItem
                id={id}
                title={title}
                onClick={onClick}
                key={id}
                itemID={itemID}
              />
            ))}
          </>
        )}
      </div>
    </DashboardLayout>
  );
});

export default Agreements;

const AgreementsItem: FC<AgreementstItemType> = memo(
  ({ title, onClick, itemID }) => {
    return (
      <button
        type="button"
        className="agreements__item"
        onClick={onClick}
        itemID={itemID}
      >
        <Typography variant="h6" component="span" align="left">
          <Box fontWeight="bold" fontSize={fontSizes.regular}>
            {title}
          </Box>
        </Typography>
        <ChevronDarkRightIcon aria-hidden="true" />
      </button>
    );
  },
);
